import React, { useState, useEffect } from "react";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import banner from "../assets/imagen.jpg";
import { Container, Row, Col, Image, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../components/dgrv.css";
import SocialBar from "../components/SocialBar";
import { useSiteSettings } from '../hooks/useSiteSettings';
import fallbackBanner from '../assets/imagen.jpg';

import spe       from "../assets/dgrv/spe.png";
import spf       from "../assets/dgrv/spf.png";
import bsc       from "../assets/dgrv/bsc.png";
import sec       from "../assets/dgrv/sec.png";
import microscore from "../assets/dgrv/microscore.png";

const API_URL = "https://facach.coop.hn/api";

// Mapa de imagen por color_class (fallback visual)
const IMG_BY_CLASS = {
  "card-soft-blue":   microscore,
  "card-soft-green":  spe,
  "card-soft-yellow": spf,
  "card-soft-pink":   bsc,
  "card-soft-cream":  sec,
};

const FALLBACK = [
  { id: 1, titulo: "Microscore",                          descripcion: "Herramienta de scoring crediticio que permite mitigar el riesgo crediticio.", color_class: "card-soft-blue" },
  { id: 2, titulo: "SPE (Sistema de Planificación Estratégica)", descripcion: "Herramienta que facilita el desarrollo de la planificación estratégica y operativa.", color_class: "card-soft-green" },
  { id: 3, titulo: "SPF (Sistema de Planificación Financiera)",  descripcion: "Herramienta que permite desarrollar el proceso presupuestario a las cooperativas.", color_class: "card-soft-yellow" },
  { id: 4, titulo: "BSC (Balance Social Cooperativo)",           descripcion: "Herramienta diseñada para facilitar la autoevaluación del impacto social y económico.", color_class: "card-soft-pink" },
  { id: 5, titulo: "SEC (Sistema de Evaluación Cooperativa)",    descripcion: "Herramienta que permite evaluar de manera cualitativa a las cooperativas.", color_class: "card-soft-cream" },
];

function DgrvCard({ item }) {
  const [expanded, setExpanded] = useState(false);
  const img = IMG_BY_CLASS[item.color_class] || microscore;

  return (
    <Card className={`dgrv-card ${item.color_class}`}>
      <Card.Body className="dgrv-card-body">
        <div className="dgrv-card-left">
          <Card.Title className="dgrv-card-title">{item.titulo}</Card.Title>
          {expanded && (
            <Card.Text className="dgrv-card-text dgrv-desc-anim">{item.descripcion}</Card.Text>
          )}
          <button className="dgrv-info-btn mt-2" onClick={() => setExpanded(!expanded)}>
            {expanded ? "Menos información ▲" : "Más información ▼"}
          </button>
        </div>
        <div className="dgrv-card-right" aria-hidden="true">
          <img src={img} alt={item.titulo} className="dgrv-product-logo" />
        </div>
      </Card.Body>
    </Card>
  );
}

const DGRV = () => {
  const { settings } = useSiteSettings();
    const bannerSrc = settings.banner_image
      ? `https://facach.coop.hn${settings.banner_image}`
      : fallbackBanner;
  const [tools, setTools]     = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch_ = async () => {
      try {
        const res = await fetch(`${API_URL}/dgrv-tools`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (json.ok && json.data?.length > 0) setTools(json.data);
      } catch (err) {
        console.error("Error cargando herramientas DGRV:", err.message);
      } finally { setLoading(false); }
    };
    fetch_();
  }, []);

  return (
    <Container fluid className="p-0 dgrv-page">
      <NavbarFacach />
      <div className="banner-wrapper">
        <Image src={bannerSrc} alt="Herramientas DGRV - FACACH" fluid className="banner-image" />
        <div className="banner-overlay">
          <h1 className="banner-title">HERRAMIENTAS DGRV</h1>
        </div>
        
      </div>

      <div className="dgrv-separator"></div>
       <Row className="justify-content-center">
    <Col xs={12} className="text-center">
      <h2 className="at-section-title">Nuestros Servicios</h2>
      <p className="at-section-subtitle">
        A través de su aliado estratégico la Confederación Alemana de Cooperativas (DGRV),
        ponemos a disposición herramientas tecnológicas para el desarrollo de las cooperativas.
      </p>
    </Col>
  </Row>

      <Container className="mt-4">
        {loading ? (
          <div className="text-center py-5" style={{ fontSize: 14, color: "#7a8aaa" }}>Cargando…</div>
        ) : (
          <Row className="g-3 g-md-4 dgrv-cards-row">
            {tools.map(item => (
              <Col key={item.id} xs={12} md={6} lg={4}>
                <DgrvCard item={item} />
              </Col>
            ))}
          </Row>
        )}

        <div className="boton-centro my-4 flex-column gap-3">
          <Button variant="primary" as={Link} to="/contacto_dgrv" className="cta-btn cta-wide">
            Contáctanos para obtener más información
          </Button>
        </div>
        <div className="boton-centro my-3">
          <Button as="a" href="/documentos/catalogo.pdf" target="_blank" rel="noopener noreferrer"
            variant="link" className="producto-vermas-link mt-auto p-0"
            style={{ color: "#252A58", textAlign: "center", opacity: "0.90" }}>
            Haz clic para ver nuestro Catálogo 
          </Button>
        </div>
      </Container>

      <SocialBar position="right" top="35%" size={42} rounded={true} />
      <FooterFacach />
    </Container>
  );
};

export default DGRV;